import React, {Fragment} from 'react';
import i18n from '../../../utilities/i18n';
import {Button, ButtonType} from '../../button/button';
import {Checkbox} from '../../checkboxes/checkbox';
import {IconCollection} from '../../../utilities/iconimport';
import SnartSluttAdvarsel from '../../snartsluttadvarsel/snartsluttadvarsel';


const StartRegistrering = (props) => {

  return (
    <Fragment>
      {props.eksisterendeLisenser.length === 0 ?
        <section className='boxMargin'>
          <h2 className='pageHeading'>{i18n.t('lisensRegistrering:ingenLisenser')}{props.jaktaar}</h2>
          <hr/>
          <SnartSluttAdvarsel jaktaar={props.jaktaar}/>
          <Button type={ButtonType.PRIMARY}
                  onClick={props.nextPage}
                  buttonId="startRegButton"
                  icon={IconCollection.registrationIcon}>
            {i18n.t('lisensRegistrering:startReg')}
          </Button>
          <hr/>
        </section>
                :
        <section>
          <h2 className='pageHeading'>{i18n.t('lisensRegistrering:noenLisenser')}{props.jaktaar}</h2>
          <hr/>
          <h3>{i18n.t('lisensRegistrering:harLisenser')}</h3>
          <div className='lisensListe'>
            {props.eksisterendeLisenser
                          .map((art) => (
                            <div key={art.artId} className='artsListeElement'>
                              <Checkbox checkboxId={art.artId}
                                        text={i18n.t('felles:' + art.beskrivelse)}
                                        disabled={true}
                                        isChecked={true}/>
                            </div>))}
          </div>
          <SnartSluttAdvarsel jaktaar={props.jaktaar}/>
          <div className='buttonDiv'>
            {props.eksisterendeLisenser.length < 4 &&
            <Button type={ButtonType.PRIMARY}
                    onClick={props.nextPage}
                    icon={IconCollection.registrationIcon}
                    buttonId="startRegButton">
              {i18n.t('lisensRegistrering:merReg')}
            </Button>}
            <Button type={ButtonType.SECONDARY}
                    icon={IconCollection.pdfIcon}
                    onClick={props.pdfDownload}
                    buttonId="downloadButton">
              {i18n.t('lisensRegistrering:lastNed')}
            </Button>
          </div>
          <hr/>
        </section>}
    </Fragment>
  );
};

export default StartRegistrering;
